import React, {useState} from 'react';
import {
    Box,
    Paper,
    Tabs,
    Tab,
} from '@mui/material';

import UsersTab from './UsersTab';
import ProductsTab from './ProductsTab';
import DbConsoleTab from './DbConsoleTab';

const styles = {
    paper: {
        p: 3,
    },
    tabs: {
        borderBottom: 1,
        borderColor: 'divider',
        mb: 3,
    },
};

export default function AdminPage() {
    const [tab, setTab] = useState(0);

    return (
        <Box>
            <Paper sx={styles.paper}>
                <Tabs
                    value={tab}
                    onChange={(e, v) => setTab(v)}
                    sx={styles.tabs}
                >
                    <Tab label="사용자 관리"/>
                    <Tab label="제품 관리"/>
                    <Tab label="DB 콘솔"/>
                </Tabs>

                {tab === 0 && <UsersTab/>}
                {tab === 1 && <ProductsTab/>}
                {tab === 2 && <DbConsoleTab/>}
            </Paper>
        </Box>
    );
}
